import { lazyLoad } from 'utils/loadable';

export const AutomationGridPage = lazyLoad(
    () => import('./index'),
    module => module.AutomationGridPage,
);